export enum TaskStatusEnum {
  TO_DO = 0,
  IN_PROGRESS = 1,
  FOR_APPROVAL = 2,
  REJECTED = 3,
  COMPLETED = 4,
}

export enum StatusEnum {
  TO_DO = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
  REJECTED = 3,
  IN_EXECUTION = 4,
}

export interface Department {
  department: string;
  department_id: number;
  status: boolean;
}

export const DepartmentDefault: Department = {
  department: "",
  department_id: 0,
  status: false,
};

export interface Position {
  position_id: number;
  position: string;
  status: boolean;
  access_to_additional_info: boolean;
  min_sum: number;
}

export const PositionDefault: Position = {
  position_id: 0,
  position: "",
  status: false,
  access_to_additional_info: false,
  min_sum: 0,
};

export interface LocationType {
  location_id: number;
  location: string;
  status: boolean;
}

export const LocationDefault: LocationType = {
  location_id: 0,
  location: "",
  status: false,
};

export interface CodeItType {
  code_it_id: number;
  code_it: string;
  status: boolean;
}

export const CodeItDefault: CodeItType = {
  code_it_id: 0,
  code_it: "",
  status: false,
};

export interface CompanyType {
  company_id: number;
  company: string;
  bin: string;
  status: boolean;
  location_id: number;
}

export const CompanyDefault: CompanyType = {
  company_id: 0,
  company: "",
  bin: "",
  status: false,
  location_id: 0,
};

export interface Budget {
  budget_type_id: number;
  name: string;
}

export const BudgetDefault: Budget = {
  budget_type_id: 0,
  name: "",
};

export interface ContractorType {
  contragent_id: number;
  contragent: string;
  bin: string;
  status: boolean;
}

export const ContractorDefault: ContractorType = {
  contragent_id: 0,
  contragent: "",
  bin: "",
  status: false,
};

export interface LevelType {
  budget_type_id: number | null;
  budget_type: string | null;
  level_number: number | null;
  parent_budget_type_id: number | null;
  direct_parent_id: number | null;
  max_levels: number | null;
  status: boolean | null;
  forecast_min_level: number | null;
  position: { x: number; y: number } | null;
  children?: LevelType[];
}

export const LevelDefault: LevelType = {
  budget_type_id: null,
  budget_type: null,
  level_number: 0,
  parent_budget_type_id: null,
  direct_parent_id: null,
  max_levels: null,
  status: null,
  forecast_min_level: null,
  position: null,
  children: [],
};

export interface LevelStructureType {
  root: LevelType[];
  children: LevelType[];
  orphans: LevelType[];
  nodes: LevelType[];
  edges: {
    parent_id: number;
    child_id: number;
  }[];
}

export interface TodoItem {
  id: number;
  title: string;
  is_completed: boolean;
  order_index: number;
}
export interface Template {
  template_id: number;
  name: string;
  type: string;
  positions: Position[];
  executor_positions: Position[];
  locations: LocationType[];
  todo_items: TodoItem[];
}
